import { Price, topliApi } from '@/shared/api/topli/TopliApi'

export const addPricesApi = async (_prices: Price[], unitId: number) => {
  const response = await topliApi.prices.addPrices({
    prices: [..._prices.map(item => ({ ...item, unit_id: unitId, main: true }))],
  })

  return response
}
